export default __webpack_public_path__ + "src/images/packages/the-african-renaissance/c6b57e5b0f6badc96e37961d9db0862c-5.jpg";